module.exports = __webpack_public_path__ + "static/media/analyzer-br.045a5089.png";